import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod, OpenApiParameterType } from '../../open-api.method';
import { config } from '../../../config';
import { PlatformConfigControllerGetAllPlatformConfigResponse } from '../../responses/platform-config-controller-get-all-platform-config.response';

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/platform-config/all',
  operationId: 'PlatformConfigController_getAllPlatformConfig',
  parameters: [
    {
      name: 'tenantId',
      required: true,
      in: OpenApiParameterType.QUERY,
    },
  ],
})
export class PlatformConfigControllerGetAllPlatformConfigMethod
  extends BaseOpenApiMethod<PlatformConfigControllerGetAllPlatformConfigResponse>
  implements Method<PlatformConfigControllerGetAllPlatformConfigResponse, void>
{
  public call(): Promise<PlatformConfigControllerGetAllPlatformConfigResponse> {
    return super.call({
      parameters: {
        tenantId: config.tenantId,
      },
    });
  }
}
